export { default as CameraSolidIcon } from './CameraSolidIcon';
